import { SpaceItemEditButton } from './space-item-edit-button.component';
import { SpaceItemAddButton } from './space-item-add-button.component';
import { SpaceItemDuplicateButton } from './space-item-duplicate-button.component';
import { SpaceHierarchyReadModel, PermissionKeys } from '@client/api';
import { useSpacePermissions } from '../../../../hooks/useSpacePermissions/useSpacePermissions';

export function SpaceSideMenuPermissionBasedCta({ item }: { item?: SpaceHierarchyReadModel }) {
  const { hasAnyPermission } = useSpacePermissions({ id: item?.id });

  const hasUpdatePermission = hasAnyPermission([PermissionKeys.Space.Update]);
  const hasCreatePermission = hasAnyPermission([PermissionKeys.Space.SubspacesCreate]);

  return (
    <div className="hidden items-center space-x-1 ml-2 group-hover:flex">
      {hasUpdatePermission && <SpaceItemEditButton item={item} />}
      {hasUpdatePermission && <SpaceItemDuplicateButton item={item} />}
      {hasCreatePermission && <SpaceItemAddButton item={item} />}
    </div>
  );
}
